import { Box, Breakpoint, Grid } from '@mui/material';
import AddressSelectorWrapper from 'src/features/addresses/presentation/components/AddressSelector/AddressSelectorWrapper';
import { FlexContainer } from '../styles';
import { layoutConfig } from 'src/common/layout/config';
import { getSubdomain } from 'src/utils/domain/getSubdomain';
import { AppSubdomains } from 'src/types/common';

interface HeaderAddressProps {
  columns?: { [key in Breakpoint]?: number };
}

const DEFAULT_COLUMNS = {
  xs: 12,
  md: 2.5,
  xl: 2.5,
};

export default function HeaderAddress({ columns }: HeaderAddressProps) {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const { defaultLayout } = layoutConfig[subdomain];

  return (
    <Grid item {...(columns ?? DEFAULT_COLUMNS)}>
      <FlexContainer
        width="100%"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
      >
        {defaultLayout.headerAddress && (
          <Box maxWidth={{ xs: '75%', sm: 450, md: '100%' }}>
            <AddressSelectorWrapper />
          </Box>
        )}
      </FlexContainer>
    </Grid>
  );
}
